import React from 'react';
import Select from 'react-select';
import Breadcrumbs from 'react-breadcrumbs';
import Toaster from 'toastr';
import {connect} from 'react-redux';
import {Permissioned} from 'react-permissions';
import Divider from '../../common/divider';
import PageTitle from '../../common/pageTitle';
import Util from '../../../util/util';
import Messages from '../../../configurations/messages';
import Constants from '../../../configurations/constants';
import ArbiterApi from '../../../api/ArbiterApi';
import TransactionTypesTable from './transactionTypesTable';
import TransactionTypesModal from './transactionTypesModal';


class TransactionTypesPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            transactionTypes: [],
            selectedTransactionType: null,
            totalCount: 0,
            loading: false,
            pages: 0,
            openModalFlag: false,
            createFlag: false,
            pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
            pageNum: 0, //Zero based index
        };
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.onTableChange = this.onTableChange.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
        this.onNewButtonClick = this.onNewButtonClick.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    componentDidMount() {

        //Get Dispute Categories
        ArbiterApi.getTransactionGroups()
            .then(response => {
                
                let transactionGroups = response.data.map(obj => {

                    obj.label = obj.name;
                    obj.value = obj.name;           
                    return obj;
                });
               
                this.setState({ transactionGroups });
            })
            .catch(error => {
                Toaster.error(`${error.status} - ${Messages.ERROR_TRANSACTION_GROUPS}`);
                console.log(error);
            })

        //Load data on mount
        this.reloadTypes();
    }

    onNewButtonClick(evt) {
        this.setState({ openModalFlag: true, createFlag: true });
    }
    handleFilterChange(evt) {
        this.setState({ transactionGroup: evt }, ()=> this.reloadTypes());
    }

    render() {
        return (

            <div>
                <div id="page-breadcrumb" className="breadcrumb-container">
                    <Breadcrumbs routes={this.props.routes}
                        params={this.props.params} />
                </div>
                <PageTitle title="Transaction Types" />
                <Divider />
                <div className="mini-filter">
                    <button onClick={this.onNewButtonClick} className="btn btn-primary right" >+ New Transaction Type</button>
                    <div className="filter-select">
                        <Select
                            placeholder="Transaction Groups"
                            onChange={this.handleFilterChange}
                            options={this.state.transactionGroups}
                            value={this.state.transactionGroup}
                        />
                    </div>
                    
                </div>
                <TransactionTypesTable
                    onRowClick={this.onRowClick}
                    loading={this.state.loading}
                    onTableChange={this.onTableChange}
                    page={this.state.pageNum}
                    pages={this.state.pages}
                    defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
                    transactionTypes={this.state.transactionTypes}
                />
                {this.state.openModalFlag &&
                    <TransactionTypesModal
                        isNew={this.state.createFlag}
                        isOpen={this.state.openModalFlag}
                        onRequestClose={this.handleCloseModal}
                        transactionType={this.state.selectedTransactionType}
                    />
                }
            </div>
        )
    }


    onTableChange(state, instance) {
        let pageSize = instance.state.pageSize;
        let pageNum = (instance.state.page); //table page  - Zero based index
        this.setState({ pageSize: pageSize, pageNum: pageNum });
        if (this.state.filterParams) {
            let params = Util.clone(this.state.filterParams);
            params.pageSize = pageSize;
            params.pageNum = pageNum + 1;

            this.loadTypes(params);
        }

    }

    loadTypes(params, resetPageNumber) {
        //Reset states 
        let stateUpdate = { loading: true };
        if (resetPageNumber) {
            stateUpdate.pageNum = 0;
            params.pageNum = 1;
        }
        this.setState(stateUpdate);
        params.pageSize = params.pageSize || this.state.pageSize;
        params.pageNum = params.pageNum || (this.state.pageNum + 1);

        let transactionGroup = this.state.transactionGroup;

        if (transactionGroup && transactionGroup.value) {
            params.group = transactionGroup.value;
        }
        ArbiterApi.getTransactionTypes(params)
            .then((response) => {
                let data = response.data.content;
                let totalCount = response.data.count;
                let pages = totalCount ? Math.ceil(totalCount / (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)) : 0;
                if (data.length === 0)
                    Toaster.warning("No records found.", "Transaction Types")
                this.setState({ transactionTypes: data, loading: false, filterParams: params, totalCount: totalCount, pages: pages });
            })
            .catch((error) => {
                console.log(error);
                Toaster.error(`${Messages.ERROR_TRANSACTION_TYPES} - ${error.data ? error.data.description : error.statusText}`, `${error.status}`);
                this.setState({ loading: false });
            });
    }

    onRowClick(index) {
        this.setState({ selectedTransactionType: this.state.transactionTypes[index], openModalFlag: true, createFlag: false });
    }
    handleCloseModal(event, reloadDataFlag) {
        this.setState({ selectedTransactionType: null, openModalFlag: false, createFlag: false });
        if (reloadDataFlag) {
            this.reloadTypes();
        }
    }

    reloadTypes() {
        this.setState({transactionTypes : []});
        this.loadTypes({ pageSize: this.state.pageSize });
    }

}


export default TransactionTypesPage;


// WEBPACK FOOTER //
// ./src/components/admin/transactionTypes/transactionTypesPage.js